import React from 'react';
import { ReactComponent as ProcuurLoadingIcon } from '../../assets/svg/procuur-loading.svg';

export default function Loading(props) {
	return (
		<>
			{props.type === 'facebook' && (
				<div className={`lds-facebook${props.size ? ` ${props.size}` : ''}`}>
					<div></div>
					<div></div>
					<div></div>
				</div>
			)}
			{props.type === 'circle' && (
				<div
					className={`lds-dual-ring${props.size ? ` ${props.size}` : ''}${
						props.size === 'btnLoad' ? ' btnLoad' : ''
					}`}
					style={{ margin: props.center ? 'auto' : '' }}></div>
			)}
			{props.type === 'procuur' && (
				<div className='procuurLoadingIconCont'>
					<ProcuurLoadingIcon />
				</div>
			)}
		</>
	);
}
